import React from 'react';
import { IconComponent } from '@shapeable/types'

export const StatusVIcon: IconComponent = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path d="M16 2.78261C23.3043 2.78261 29.2174 8.69565 29.2174 16C29.2174 23.3043 23.3043 29.2174 16 29.2174C8.69565 29.2174 2.78261 23.3043 2.78261 16C2.78261 8.69565 8.69565 2.78261 16 2.78261ZM16 0C7.16522 0 0 7.16522 0 16C0 24.8348 7.16522 32 16 32C24.8348 32 32 24.8348 32 16C32 7.16522 24.8348 0 16 0Z" fill="black"/>
  <path d="M14.6174 21L11 11H13.4759L15.1479 15.7994L16.0322 18.937H16.0804L16.9325 15.7994L18.6045 11H21L17.3505 21H14.6174Z" fill="black"/>
  </svg>
);